var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3083 15.0013V15.8346C18.3083 17.2096 18.3083 18.3346 15.8083 18.3346H4.1416C1.6416 18.3346 1.6416 17.2096 1.6416 15.8346V15.0013C1.6416 14.543 2.0166 14.168 2.47493 14.168H17.4749C17.9333 14.168 18.3083 14.543 18.3083 15.0013Z",
    fill: "#8392A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.2663 10.8346V14.168H2.72461V10.8346C2.72461 7.63464 4.98294 4.95964 7.99128 4.31797C8.44128 4.21797 8.90794 4.16797 9.39128 4.16797H10.5996C11.0829 4.16797 11.5579 4.21797 12.0079 4.31797C15.0163 4.96797 17.2663 7.63464 17.2663 10.8346Z",
    fill: "#8392A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0837 3.7513C12.0837 3.9513 12.0587 4.13464 12.0087 4.31797C11.5587 4.21797 11.0837 4.16797 10.6003 4.16797H9.39199C8.90866 4.16797 8.44199 4.21797 7.99199 4.31797C7.94199 4.13464 7.91699 3.9513 7.91699 3.7513C7.91699 2.6013 8.85033 1.66797 10.0003 1.66797C11.1503 1.66797 12.0837 2.6013 12.0837 3.7513Z",
    fill: "#8392A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.79297H7.5C7.15833 9.79297 6.875 9.50964 6.875 9.16797C6.875 8.8263 7.15833 8.54297 7.5 8.54297H12.5C12.8417 8.54297 13.125 8.8263 13.125 9.16797C13.125 9.50964 12.8417 9.79297 12.5 9.79297Z",
    fill: "#8392A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryActive);
export default __webpack_public_path__ + "static/media/category-active.eb903b51b3a59d50aae8d6f5be5eec7e.svg";
export { ForwardRef as ReactComponent };